/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Banned_OkInputs */

const fr_account_audit_banned_ok = /** @type {(inputs: Account_Audit_Banned_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte non bloqué`)
};

/**

* @param {Account_Audit_Banned_OkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_banned_ok = /** @type {((inputs?: Account_Audit_Banned_OkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Banned_OkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_banned_ok(inputs)
});